import { LoaderCircleIcon } from 'lucide-react';

import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { cn } from 'utils/shadcn';

import { BatchLTLShipmentStatus } from './types';

const STATUS_LABELS: Record<BatchLTLShipmentStatus, string> = {
  [BatchLTLShipmentStatus.Invalid]: 'Missing info',
  [BatchLTLShipmentStatus.Ready]: 'Ready',
  [BatchLTLShipmentStatus.Rating]: 'Rating',
  [BatchLTLShipmentStatus.Rated]: 'Rated',
  [BatchLTLShipmentStatus.InReply]: 'In reply',
  [BatchLTLShipmentStatus.Failed]: 'No rates',
};

const STATUS_CHIP_CLASSES: Record<BatchLTLShipmentStatus, string> = {
  [BatchLTLShipmentStatus.Invalid]: 'bg-error-50 text-error-700',
  [BatchLTLShipmentStatus.Ready]: 'bg-neutral-100 text-neutral-700',
  [BatchLTLShipmentStatus.Rating]: 'bg-info-50 text-info-700',
  [BatchLTLShipmentStatus.Rated]: 'bg-success-50 text-success-700',
  [BatchLTLShipmentStatus.InReply]: 'bg-success-100 text-success-700',
  [BatchLTLShipmentStatus.Failed]: 'bg-error-100 text-error-700',
};

// Typography sets its own text color, so the chip text needs the matching token.
const STATUS_TEXT_CLASSES: Record<BatchLTLShipmentStatus, string> = {
  [BatchLTLShipmentStatus.Invalid]: 'text-error-700',
  [BatchLTLShipmentStatus.Ready]: 'text-neutral-700',
  [BatchLTLShipmentStatus.Rating]: 'text-info-700',
  [BatchLTLShipmentStatus.Rated]: 'text-success-700',
  [BatchLTLShipmentStatus.InReply]: 'text-success-700',
  [BatchLTLShipmentStatus.Failed]: 'text-error-700',
};

type BatchLTLStatusChipProps = {
  status: BatchLTLShipmentStatus;
  rateCount?: number;
};

export function BatchLTLStatusChip({
  status,
  rateCount,
}: BatchLTLStatusChipProps) {
  return (
    <Flex
      align='center'
      gap='xs'
      shrink='0'
      data-testid='batch-ltl-status-chip'
      className={cn('rounded-full px-2 py-0.5', STATUS_CHIP_CLASSES[status])}
    >
      {status === BatchLTLShipmentStatus.Rating && (
        <LoaderCircleIcon className='h-3 w-3 animate-spin' />
      )}
      <Typography
        variant='body-xxs'
        weight='semibold'
        className={STATUS_TEXT_CLASSES[status]}
        as='span'
      >
        {STATUS_LABELS[status]}
        {rateCount ? ` · ${rateCount}` : ''}
      </Typography>
    </Flex>
  );
}
